import React from 'react';
import { useFormContext, Controller, UseFormGetValues } from 'react-hook-form';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  createStyles,
  makeStyles,
  Theme
} from '@material-ui/core';

type TProps = {
  name: any;
  listDatas: {
    name: string;
    value: string;
  }[];
  getValues: UseFormGetValues<any>;
  onChange?: any;
  notFlexRow?: boolean;
};

export const SiteProcessRadioGroup: React.VFC<TProps> = React.memo(
  (props: TProps) => {
    const { name, listDatas, getValues, onChange, notFlexRow = false } = props;

    // react-hook-formを使用する前提のcomponent
    const { register, control } = useFormContext();

    const classes = useStyles();

    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <RadioGroup
            {...register(name)}
            className={notFlexRow ? '' : classes.radioGroup}
          >
            {listDatas.map((orderType, index) => {
              return (
                <FormControlLabel
                  value={orderType.value}
                  control={
                    <Radio
                      name={name + index.toString()}
                      onChange={onChange}
                      checked={orderType.value === getValues(name)}
                      color='primary'
                    />
                  }
                  label={orderType.name}
                />
              );
            })}
          </RadioGroup>
        )}
      />
    );
  }
);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    radioGroup: {
      flexDirection: 'row'
    }
  })
);
